import React from "react"

//Pages
import Pages404 from "../pages/Utility/pages-404"
import Pages500 from "../pages/Utility/pages-500"

import TicketClient from "pages/Ticket/TicketClient"

const authProtectedRoutes = [
  // Home
]

const publicRoutes = [
  { path: "/", component: <TicketClient /> },
  { path: "/:clientToken", component: <TicketClient /> },

  { path: "/pages-500", component: <Pages500 /> },

  { path: "/*", component: <Pages404 /> },
]

export { authProtectedRoutes, publicRoutes }
